import { useLanguage } from "../i18n/LanguageProvider";

/**
 * "Learn from it without being defined by it", drawn as two paths out of
 * one setback: a line that climbs past where it started, and a dashed
 * branch that flattens out and ends.
 *
 * The resting state is the finished drawing; the entrance animation only
 * runs once an enclosing ScrollReveal marks itself revealed, so reduced
 * motion and no-JS readers see the complete figure.
 */
export const CoreIdeaDiagram = () => {
  const { t } = useLanguage();

  return (
    <svg
      className="gw-coreidea__svg"
      viewBox="0 0 440 230"
      role="img"
      aria-label={t("about.coreIdeaDiagram")}
    >
      <defs>
        <linearGradient id="gw-coreidea-stroke" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0%" stopColor="#002364" />
          <stop offset="55%" stopColor="#0078d7" />
          <stop offset="100%" stopColor="#6fb6ec" />
        </linearGradient>
      </defs>

      <path className="gw-coreidea__baseline" d="M16 96H424" />

      <g className="gw-coreidea__stuck">
        <path d="M192 166C250 168 320 176 384 182" />
        <path d="M389 176l14 14M403 176l-14 14" />
        <text x="404" y="212" textAnchor="end">
          {t("about.coreIdeaDefined")}
        </text>
      </g>

      <path
        className="gw-coreidea__line"
        d="M16 96C70 96 108 98 138 132C156 152 172 166 192 166C214 166 236 150 262 126C310 82 352 58 414 40"
        pathLength={1}
        stroke="url(#gw-coreidea-stroke)"
      />

      <g className="gw-coreidea__growth">
        <path d="M400.4 36.7L414 40l-9.7 10.1" stroke="#6fb6ec" />
        <text x="414" y="20" textAnchor="end">
          {t("about.coreIdeaGrow")}
        </text>
      </g>

      <g className="gw-coreidea__setback">
        <circle cx="192" cy="166" r="15" className="gw-coreidea__halo" />
        <circle cx="192" cy="166" r="6.5" className="gw-coreidea__dot" />
        <text x="192" y="200" textAnchor="middle">
          {t("about.coreIdeaSetback")}
        </text>
      </g>
    </svg>
  );
};
